import { TelehealthCta } from "@/components/site/TelehealthCta";
import { SectionCta } from "@/components/site/SectionCta";
import { createFileRoute, Link } from "@tanstack/react-router";
import { LastUpdated } from "@/components/site/LastUpdated";
import { ImageLightbox } from "@/components/site/ImageLightbox";
import { canonicalAndAlternates } from "@/lib/hreflang";
import { faqPageJson } from "@/lib/faq-schema";
import sleeveWeightLossGraph from "@/assets/sleeve-excess-weight-loss-percentage-graph.png.asset.json";
import sleeveGastrectomy from "@/assets/sleeve-gastrectomy-v2-800.jpg.asset.json";
import sleeveEndoscopyCheck from "@/assets/sleeve-endoscopy-check.png.asset.json";
import sleeveEndoscopyCheck480 from "@/assets/sleeve-endoscopy-check-en-480.webp.asset.json";
import sleeveEndoscopyCheck800 from "@/assets/sleeve-endoscopy-check-en-800.webp.asset.json";
import sleeveEndoscopyCheck1200 from "@/assets/sleeve-endoscopy-check-en-1200.webp.asset.json";
import sleeveGastrectomyJpg1200 from "@/assets/sleeve-gastrectomy-v2-1200.jpg.asset.json";
import sleeveGastrectomyJpg1536 from "@/assets/sleeve-gastrectomy-v2-1536.jpg.asset.json";
import sleeveFitzer1 from "@/assets/sleeve-fitzer-1.png.asset.json";
import sleeveFitzer2 from "@/assets/sleeve-fitzer-2.png.asset.json";
import sleeveFitzer3 from "@/assets/sleeve-fitzer-3.jpg.asset.json";
import sleeveAmateur1 from "@/assets/sleeve-amateur-1.jpg.asset.json";
import sleeveAmateur2 from "@/assets/sleeve-amateur-2.png.asset.json";
import sleeveAmateur3 from "@/assets/sleeve-amateur-3.png.asset.json";
import sleeveRefluxNormalAsset from "@/assets/reflux-stomach-before.png.asset.json";
const sleeveRefluxNormal = sleeveRefluxNormalAsset.url;
import sleeveRefluxPostSleeveAsset from "@/assets/reflux-sleeve-after.png.asset.json";
const sleeveRefluxPostSleeve = sleeveRefluxPostSleeveAsset.url;
import sleeveWeightLossGraphWebp from "@/assets/sleeve-excess-weight-loss-percentage-graph.webp.asset.json";
import sleeveWeightLossGraph720 from "@/assets/sleeve-excess-weight-loss-percentage-graph-720.png.asset.json";
import sleeveWeightLossGraphWebp720 from "@/assets/sleeve-excess-weight-loss-percentage-graph-720.webp.asset.json";
import sleeveGastrectomyWebp800 from "@/assets/sleeve-gastrectomy-v2-800.webp.asset.json";
import sleeveGastrectomyWebp1200 from "@/assets/sleeve-gastrectomy-v2-1200.webp.asset.json";
import sleeveGastrectomyWebp1536 from "@/assets/sleeve-gastrectomy-v2-1536.webp.asset.json";
import sleeveFitzer1Webp from "@/assets/sleeve-fitzer-1.webp.asset.json";
import sleeveFitzer2Webp from "@/assets/sleeve-fitzer-2.webp.asset.json";
import sleeveFitzer3Webp from "@/assets/sleeve-fitzer-3.webp.asset.json";
import sleeveAmateur1Webp from "@/assets/sleeve-amateur-1.webp.asset.json";
import sleeveAmateur2Webp from "@/assets/sleeve-amateur-2.webp.asset.json";
import sleeveAmateur3Webp from "@/assets/sleeve-amateur-3.webp.asset.json";
import sleeveAmateur1Jpg680 from "@/assets/sleeve-amateur-1-680.jpg.asset.json";
import sleeveAmateur1Webp680 from "@/assets/sleeve-amateur-1-680.webp.asset.json";
import sleeveAmateur2Png680 from "@/assets/sleeve-amateur-2-680.png.asset.json";
import sleeveAmateur2Webp680 from "@/assets/sleeve-amateur-2-680.webp.asset.json";
import sleeveFitzer2Png680 from "@/assets/sleeve-fitzer-2-680.png.asset.json";
import sleeveFitzer2Webp680 from "@/assets/sleeve-fitzer-2-680.webp.asset.json";
import sleeveFitzer3Jpg680 from "@/assets/sleeve-fitzer-3-680.jpg.asset.json";
import sleeveFitzer3Webp680 from "@/assets/sleeve-fitzer-3-680.webp.asset.json";
import sleeveRefluxNormalWebpAsset from "@/assets/reflux-stomach-before.webp.asset.json";
const sleeveRefluxNormalWebp = sleeveRefluxNormalWebpAsset.url;
import sleeveRefluxPostSleeveWebpAsset from "@/assets/reflux-sleeve-after.webp.asset.json";
const sleeveRefluxPostSleeveWebp = sleeveRefluxPostSleeveWebpAsset.url;
import sleeveRefluxNormalWebp680 from "@/assets/reflux-stomach-before-680.webp.asset.json";
import sleeveRefluxNormalPng680 from "@/assets/reflux-stomach-before-680.png.asset.json";
import sleeveRefluxPostSleeveWebp680 from "@/assets/reflux-sleeve-after-680.webp.asset.json";
import sleeveRefluxPostSleevePng680 from "@/assets/reflux-sleeve-after-680.png.asset.json";
import sleeveAmateur1Jpg220 from "@/assets/sleeve-amateur-1-220.jpg.asset.json";
import sleeveAmateur1Webp220 from "@/assets/sleeve-amateur-1-220.webp.asset.json";
import sleeveAmateur1Jpg440 from "@/assets/sleeve-amateur-1-440.jpg.asset.json";
import sleeveAmateur1Webp440 from "@/assets/sleeve-amateur-1-440.webp.asset.json";
import sleeveAmateur2Png220 from "@/assets/sleeve-amateur-2-220.png.asset.json";
import sleeveAmateur2Webp220 from "@/assets/sleeve-amateur-2-220.webp.asset.json";
import sleeveAmateur2Png440 from "@/assets/sleeve-amateur-2-440.png.asset.json";
import sleeveAmateur2Webp440 from "@/assets/sleeve-amateur-2-440.webp.asset.json";
import sleeveAmateur3Png220 from "@/assets/sleeve-amateur-3-220.png.asset.json";
import sleeveAmateur3Webp220 from "@/assets/sleeve-amateur-3-220.webp.asset.json";
import sleeveAmateur3Png440 from "@/assets/sleeve-amateur-3-440.png.asset.json";
import sleeveAmateur3Webp440 from "@/assets/sleeve-amateur-3-440.webp.asset.json";
import sleeveFitzer1Png220 from "@/assets/sleeve-fitzer-1-220.png.asset.json";
import sleeveFitzer1Webp220 from "@/assets/sleeve-fitzer-1-220.webp.asset.json";
import sleeveFitzer1Png440 from "@/assets/sleeve-fitzer-1-440.png.asset.json";
import sleeveFitzer1Webp440 from "@/assets/sleeve-fitzer-1-440.webp.asset.json";
import sleeveFitzer2Png220 from "@/assets/sleeve-fitzer-2-220.png.asset.json";
import sleeveFitzer2Webp220 from "@/assets/sleeve-fitzer-2-220.webp.asset.json";
import sleeveFitzer2Png440 from "@/assets/sleeve-fitzer-2-440.png.asset.json";
import sleeveFitzer2Webp440 from "@/assets/sleeve-fitzer-2-440.webp.asset.json";
import sleeveFitzer3Jpg220 from "@/assets/sleeve-fitzer-3-220.jpg.asset.json";
import sleeveFitzer3Webp220 from "@/assets/sleeve-fitzer-3-220.webp.asset.json";
import sleeveFitzer3Jpg440 from "@/assets/sleeve-fitzer-3-440.jpg.asset.json";
import sleeveFitzer3Webp440 from "@/assets/sleeve-fitzer-3-440.webp.asset.json";
import sleevePostoperativeDiet from "@/assets/Sleeve_Postoperative_Diet.pdf.asset.json";
import { WeightLossOptionsButtons } from "@/components/site/WeightLossOptionsButtons";
import { InlineAppointmentCTA } from "@/components/site/InlineAppointmentCTA";
import { MedicalReviewBanner } from "@/components/site/MedicalReview";
import { medicalWebPageScript, imageRights, PROCEDURE_ACTORS, SETTING_ONE_NIGHT } from "@/lib/medical-schema";

const SLEEVE_IMAGE_RIGHTS = imageRights("https://virginiabariatric.com/services/sleeve");

export const Route = createFileRoute("/services/sleeve")({
  head: () => ({
    meta: [
      { title: "Sleeve Gastrectomy in Northern Virginia | Virginia Bariatric" },
      {
        name: "description",
        content:
          "Sleeve gastrectomy, also called the sleeve operation, in Northern Virginia. Dr. Fitzer's patients average ~70% excess weight loss.",
      },
      ...(import.meta.env.SSR ? [
        { property: "og:title", content: "Sleeve Gastrectomy in Northern Virginia | Virginia Bariatric" },
        { property: "og:description", content: "Sleeve gastrectomy, also called the sleeve operation, in Northern Virginia. Dr. Fitzer's patients average ~70% excess weight loss." },
        { property: "og:url", content: "https://virginiabariatric.com/services/sleeve" },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { property: "og:locale:alternate", content: "es_LA" },
        { property: "og:image", content: `https://virginiabariatric.com${sleeveGastrectomy.url}` },
        { property: "og:image:alt", content: "Medical diagram of laparoscopic sleeve gastrectomy showing the removed stomach and narrow gastric sleeve" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:image", content: `https://virginiabariatric.com${sleeveGastrectomy.url}` },
        { name: "twitter:image:alt", content: "Medical diagram of laparoscopic sleeve gastrectomy showing the removed stomach and narrow gastric sleeve" },
        { name: "twitter:title", content: "Sleeve Gastrectomy in Northern Virginia | Virginia Bariatric" },
        { name: "twitter:description", content: "Sleeve gastrectomy, also called the sleeve operation, in Northern Virginia. Dr. Fitzer's patients average ~70% excess weight loss." },
      ] : []),
    ],
    links: [
      ...(import.meta.env.SSR ? canonicalAndAlternates("/services/sleeve") : []),
      // No image preload here: the measured LCP element on this page is the
      // intro paragraph, so a high-priority image fetch only steals bandwidth
      // from the render-blocking stylesheet.
    ],

    scripts: import.meta.env.SSR ? [
      ...medicalWebPageScript("/services/sleeve"),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "MedicalProcedure",
              "@id": "https://virginiabariatric.com/services/sleeve#procedure",
              mainEntityOfPage: { "@id": "https://virginiabariatric.com/services/sleeve#webpage" },
              procedureType: "https://schema.org/SurgicalProcedure",
              name: "Gastric Sleeve Surgery (Laparoscopic Sleeve Gastrectomy)",
              description:
                "Laparoscopic sleeve gastrectomy performed by Dr. Matthew Fitzer in Northern Virginia. Removes about 80% of the stomach for durable weight loss averaging ~70% excess weight loss.",
              url: "https://virginiabariatric.com/services/sleeve",
              image: [
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveGastrectomyJpg1536.url}`,
              url: `https://virginiabariatric.com${sleeveGastrectomyJpg1536.url}`,
               caption: "Medical diagram of laparoscopic sleeve gastrectomy showing the removed stomach and narrow gastric sleeve",
              representativeOfPage: true,
               width: 1536,
               height: 1024,
              ...SLEEVE_IMAGE_RIGHTS,
              creditText: "Matthew Fitzer, MD, with AI assistance",
              creator: { "@type": "Person", name: "Matthew Fitzer, MD" },
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveWeightLossGraph.url}`,
              url: `https://virginiabariatric.com${sleeveWeightLossGraph.url}`,
              caption: "Average excess weight loss percentage after laparoscopic sleeve gastrectomy at Virginia Bariatric Surgery, from 1 month through 9 years",
              name: "Laparoscopic sleeve gastrectomy 10-year excess weight loss chart",
              description:
                "Line chart showing average excess weight loss percentage for Dr. Fitzer's laparoscopic sleeve gastrectomy patients at Virginia Bariatric Surgery, measured from 1 month through 9 years after surgery.",
              width: 1920,
              height: 780,
              inLanguage: "en-US",
              datePublished: "2026-07-29",
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveFitzer1.url}`,
              url: `https://virginiabariatric.com${sleeveFitzer1.url}`,
              caption: "Upper GI contrast study of a properly narrowed gastric sleeve created by Dr. Fitzer at Virginia Bariatric Surgery",
              width: 680,
              height: 680,
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveFitzer2.url}`,
              url: `https://virginiabariatric.com${sleeveFitzer2.url}`,
              caption: "Post-operative imaging of a slim, tubular gastric sleeve after laparoscopic sleeve gastrectomy by Dr. Fitzer",
              width: 823,
              height: 823,
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveFitzer3.url}`,
              url: `https://virginiabariatric.com${sleeveFitzer3.url}`,
              caption: "Contrast imaging of a Dr. Fitzer sleeve gastrectomy showing correct narrow diameter along the entire staple line",
              width: 833,
              height: 833,
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveAmateur1.url}`,
              url: `https://virginiabariatric.com${sleeveAmateur1.url}`,
              caption: "Dilated, over-large sleeve gastrectomy referred to Dr. Fitzer for revisional bariatric surgery",
              width: 829,
              height: 829,
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveAmateur2.url}`,
              url: `https://virginiabariatric.com${sleeveAmateur2.url}`,
              caption: "Upper GI study showing an incomplete 'trimmed' sleeve gastrectomy with retained fundus, sent to Dr. Fitzer for repair",
              width: 1167,
              height: 1167,
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveAmateur3.url}`,
              url: `https://virginiabariatric.com${sleeveAmateur3.url}`,
              caption: "CT scan of an oversized post-sleeve stomach with poor restriction, evaluated by Dr. Fitzer for sleeve revision surgery",
              width: 685,
              height: 685,
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveEndoscopyCheck.url}`,
              url: `https://virginiabariatric.com${sleeveEndoscopyCheck.url}`,
              caption: "Endoscopy check after completion of sleeve: it's the best way to confirm that there is nothing to be fixed. It also allows a leak check. It's similar to how leaks are found in car tires.",
              width: 1461,
              height: 814,
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveRefluxNormal}`,
              url: `https://virginiabariatric.com${sleeveRefluxNormal}`,
              caption: "Patient with normal stomach sleeping flat on back",
              width: 1335,
              height: 682,
              ...SLEEVE_IMAGE_RIGHTS,
            },
            {
              "@type": "ImageObject",
              contentUrl: `https://virginiabariatric.com${sleeveRefluxPostSleeve}`,
              url: `https://virginiabariatric.com${sleeveRefluxPostSleeve}`,
              caption: "Sleeve gastrectomy patient sleeping flat on back (supine)",
              width: 1335,
              height: 682,
              ...SLEEVE_IMAGE_RIGHTS,
            },
          ],
              bodyLocation: "Stomach",
              howPerformed:
                "Dr. Fitzer performs the sleeve laparoscopically through several small incisions, dividing the stomach with a surgical stapler and removing roughly 80% of it, leaving a narrow, banana-shaped tube. The intestines are not rerouted. " + SETTING_ONE_NIGHT,
              preparation:
                "Pre-operative evaluation includes nutrition counseling, medical clearance, and a short pre-surgery liquid diet.",
              followup:
                "Overnight hospital stay, a staged liquid-to-solid diet over about eight weeks, and long-term follow-up with lifelong vitamin supplementation.",
              relevantSpecialty: { "@type": "MedicalSpecialty", name: "Surgery" },
              ...PROCEDURE_ACTORS,
            },
            // Business identity comes from the single sitewide
            // MedicalClinic/Organization node in src/routes/__root.tsx.
          ],
        }),

      },
      {
        type: "application/ld+json",
        children: faqPageJson({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "@id": "https://virginiabariatric.com/services/sleeve#faq",
          mainEntity: [
            {
              "@type": "Question",
              name: "Is any part of my stomach or intestine bypassed?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "No. The sleeve removes part of your stomach, but it does not reroute your intestines. Food follows its normal path. That is one reason nutrient absorption holds up better than it does after a gastric bypass.",
              },
            },
            {
              "@type": "Question",
              name: "Sleeve or bypass — which is better?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Both are excellent operations, with similar weight loss and similar rates of diabetes remission. The sleeve is simpler and carries fewer complications. Bypass is often the better choice if you have significant acid reflux or certain metabolic conditions. The right answer is individual. See our detailed sleeve vs. bypass comparison for a side-by-side look.",
                url: "https://virginiabariatric.com/services/bypass-vs-sleeve",
              },
            },
            {
              "@type": "Question",
              name: "Can the sleeve be reversed?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "No. Part of your stomach is removed permanently, so the sleeve cannot be undone. It can, however, be converted to another operation later if you ever need that.",
              },
            },
            {
              "@type": "Question",
              name: "How long is recovery after gastric sleeve surgery?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Most patients stay one night in the hospital and return to normal activities within about four weeks. You start on a liquid diet right away, then move through pureed, soft, and regular foods over the next eight weeks.",
              },
            },
            {
              "@type": "Question",
              name: "Is gastric sleeve covered by insurance?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Many major insurers cover sleeve gastrectomy when you meet their medical criteria, usually a BMI of 40 or higher, or 35 or higher with an obesity-related condition. Our team verifies your benefits and walks you through authorization. Our insurance coverage guide has plan-specific detail on Anthem BCBS, Aetna, Medicare, and others.",
              },
            },
            {
              "@type": "Question",
              name: "What diet do I follow after sleeve gastrectomy?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Eating advances week by week for eight weeks: clear liquids, then full liquids and protein shakes, then pureed and soft foods, and finally regular solid food. Sleeve-specific diet instructions can be found here, Our dietitian is there to support you through every stage.",
                url: "https://virginiabariatric.com/__l5e/assets-v1/355e20f1-06ea-4693-84a3-46faef7343f6/Sleeve_Postoperative_Diet.pdf",
              },
            },
          ],

        }),
      },
    ] : [],
  }),
  component: SleevePage,
});

function SleevePage() {
  return (
    <article className="mx-auto max-w-3xl px-6 md:px-12 lg:px-32 xl:px-44 2xl:px-56 pt-4 pb-10 md:text-[1.125rem] leading-[1.6]">
      <header>
        <h1 className="text-[2.025rem] md:text-[2.7rem] font-serif text-center">Gastric Sleeve Surgery in Northern Virginia</h1>
        <p className="mt-1 italic text-foreground/70">Laparoscopic sleeve gastrectomy — the most widely performed weight-loss operation</p>
      </header>

      <TelehealthCta />

      <MedicalReviewBanner className="mt-4" />


      <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
        <div className="space-y-3">
          <p className="text-foreground/80">
            Gastric sleeve surgery is the most common weight loss surgery in the world. You may also
            hear it called laparoscopic sleeve gastrectomy, vertical sleeve gastrectomy (VSG), or
            simply "the sleeve."
          </p>

          <h2 className="text-[1.35rem] md:text-[1.6875rem] font-serif">How the sleeve works</h2>


          <p className="text-foreground/80">
            The operation removes about 80% of the stomach and leaves a slim, banana-shaped tube
            behind. That smaller stomach holds far less food, so it limits food intake. Used right,
            it gives you a strong sense of fullness after a surprisingly small amount of food.
          </p>
          <p className="text-foreground/80">
            It also works through hormonal changes. The part of the stomach we remove is the main
            source of ghrelin, a powerful hunger hormone. Together, the two effects create
            substantial, lasting weight loss and relief from obesity-related health problems.
          </p>
        </div>

        <figure className="flex flex-col items-center md:sticky md:top-4">
          <ImageLightbox
            fullSrc={sleeveGastrectomyJpg1536.url}
            fullWidth={1536}
            fullHeight={1024}
            alt="Medical diagram of laparoscopic sleeve gastrectomy showing the removed stomach and narrow gastric sleeve"
            caption="Laparoscopic sleeve gastrectomy (VSG)"
          >
            <picture>
              <source
                srcSet={`${sleeveGastrectomyWebp800.url} 800w, ${sleeveGastrectomyWebp1200.url} 1200w, ${sleeveGastrectomyWebp1536.url} 1536w`}
                type="image/webp"
                sizes="(min-width: 768px) 448px, calc(100vw - 48px)"
              />
              <img
                src={sleeveGastrectomy.url}
                srcSet={`${sleeveGastrectomy.url} 800w, ${sleeveGastrectomyJpg1200.url} 1200w, ${sleeveGastrectomyJpg1536.url} 1536w`}
                sizes="(min-width: 768px) 448px, calc(100vw - 48px)"
                alt="Medical diagram of laparoscopic sleeve gastrectomy showing the removed stomach and narrow gastric sleeve"
                width={1536}
                height={1024}
                loading="eager"
                fetchPriority="low"
                decoding="async"

                className="w-full h-auto max-w-md rounded-lg"
              />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-2 text-center text-sm text-foreground/70">
            Laparoscopic sleeve gastrectomy (VSG)
          </figcaption>
        </figure>
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3 rounded-lg border border-border p-4">
        <div className="text-center">
          <p className="text-2xl font-serif text-brand-mid">~70% EWL</p>
          <p className="mt-1 text-sm text-foreground/70">average excess weight loss in the first 1–2 years</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-serif text-brand-mid">~80%</p>
          <p className="mt-1 text-sm text-foreground/70">of the stomach is removed to form the sleeve</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-serif text-brand-mid">#1</p>
          <p className="mt-1 text-sm text-foreground/70">the most common weight-loss operation worldwide</p>
        </div>
      </div>

      <InlineAppointmentCTA
        heading="Considering the sleeve operation?"
        body="Dr. Fitzer performs sleeve gastrectomy laparoscopically for patients throughout Northern Virginia. Request a consultation to review your history, goals, and whether the sleeve is the right fit."
        buttonText="Schedule an Appointment to discuss sleeve surgery"
        secondaryButton={{ text: "Check Gastric Sleeve Insurance Coverage", to: "/resources/insurance-coverage" }}
      />

      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Who is a candidate for sleeve gastrectomy?</h2>
      <p className="mt-3 text-foreground/80">
        We offer the sleeve to adults with a body mass index (BMI) of 35 or higher. A BMI of 30 or
        higher also qualifies if you have an obesity-related health condition. For patients of East
        Asian descent, those numbers drop to 32.5 and 27.5.
      </p>
      <p className="mt-3 text-foreground/80">
        But your BMI is not the whole picture. We look at your medical history. We look at what you
        have already tried through diet and exercise. And we look at whether you are ready to change
        how you eat for good. See our full{" "}
        <Link to="/resources/qualifications" className="text-brand-deep underline hover:no-underline">
          bariatric surgery requirements
        </Link>{" "}
        for BMI thresholds, comorbidity criteria, and age guidance.
      </p>
      <p className="mt-3 text-foreground/80">
        The presence of acid reflux (GERD) may impact the decision whether to get a sleeve. The
        sleeve can trigger new acid reflux, and it often worsens existing reflux. If you already have
        bad reflux, a gastric bypass may suit you better. Bypass usually improves reflux. It rarely
        makes it worse. Dr. Fitzer will discuss this and other considerations with you.
      </p>

      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">What happens during the operation</h2>
      <p className="mt-3 text-foreground/80">
        Dr. Fitzer performs the sleeve laparoscopically, with the patient under general anesthesia.
        He uses what we call the minimally invasive approach, which avoids a long incision. Instead, he
        works through five small incisions using slender instruments. Small incisions mean faster recovery and
        fewer wound problems.
      </p>
      <p className="mt-3 text-foreground/80">
        During surgery, the stomach is cut into two pieces. One piece is the narrow tube—the sleeve—which stays in. The other piece is the larger, sack like part of the stomach. That piece comes out (through a surprisingly small hole).
      </p>
      <p className="mt-3 text-foreground/80">
        After the sleeve is created, Dr. Fitzer performs endoscopy. He scrubs out, and places a gastroscope into the esophagus. He uses it to inspect the entire sleeve, cm for cm. That way, he can be sure there is nothing that needs attention (like bleeding, a kink, etc.). The below image shows what the stomach looks like during the endoscopy.
      </p>
      <figure className="mt-2 md:max-w-[70%] md:mx-auto">
        <ImageLightbox
          fullSrc={sleeveEndoscopyCheck.url}
          fullWidth={1461}
          fullHeight={814}
          alt="Laparoscopic view of the completed gastric sleeve during the endoscopy check, with the abdomen filled with sterile water"
          caption="Endoscopy check after completion of sleeve: it's the best way to confirm that there is nothing to be fixed. It also allows a leak check. It's similar to how leaks are found in car tires. The sleeve is filled with air, and then we submerge it in water. (The water you see was pumped in for this purpose. It's special, sterile water.) If there are no visible bubbles, there's no leak."
        >
          <img
            src={sleeveEndoscopyCheck800.url}
            srcSet={`${sleeveEndoscopyCheck480.url} 480w, ${sleeveEndoscopyCheck800.url} 800w, ${sleeveEndoscopyCheck1200.url} 1200w`}
            sizes="(min-width: 768px) 70vw, calc(100vw - 2rem)"
            alt="Laparoscopic view of the completed gastric sleeve during the endoscopy check, with the abdomen filled with sterile water"
            width={1461}
            height={814}
            loading="lazy"
            decoding="async"
            className="block w-full h-auto rounded-lg"
          />
        </ImageLightbox>
        <figcaption className="mt-2 text-center text-sm text-muted-foreground">
          Endoscopy check after completion of sleeve: it's the best way to confirm that there is nothing to be fixed. It also allows a leak check. It's similar to how leaks are found in car tires. The sleeve is filled with air, and then we submerge it in water. (The water you see was pumped in for this purpose. It's special, sterile water.) If there are no visible bubbles, there's no leak.
        </figcaption>
      </figure>
      <p className="mt-3 text-foreground/80">
        The small intestine is left alone. Because food still travels its normal path, your body
        absorbs nutrients the same as it did before, and the risk of nutritional deficiency is
        lower than with operations that reroute the bowel.
      </p>
      <p className="mt-3 text-foreground/80">
        One thing to understand: the sleeve is not reversible. If we take a part of the stomach out,
        there's no way to save it for later. The sleeve can, however, be converted to another operation
        if problems come up.
      </p>
      <p className="mt-3 text-foreground/80">
        Most cases take 35 to 75 minutes.{" "}
        <a
          href="https://www.youtube.com/watch?v=HIuVAjZQe-o"
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand-logo underline hover:opacity-80"
        >
          You can watch Dr. Fitzer perform a sleeve on our YouTube channel.
        </a>
      </p>

      <p className="mt-3 text-foreground/80">
        Weighing the sleeve against the bypass? See our{" "}
        <Link to="/services/bypass-vs-sleeve" className="text-brand-deep underline hover:no-underline">
          side-by-side comparison of gastric bypass and sleeve gastrectomy
        </Link>
        .
      </p>

      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">How much weight will I lose after sleeve gastrectomy?</h2>
      <h3 className="mt-3 font-semibold text-foreground">Long-term weight loss outcomes</h3>
      <p className="mt-3 text-foreground/80">
        Sleeve patients lose more weight than LAP-BAND patients, though somewhat less than gastric
        bypass patients. Among Virginia Bariatric patients, excess weight loss averages over 70%
        from year one through year nine. Below is a graph of average % excess weight loss of Dr.
        Fitzer's actual sleeve patients from year one through year nine following their surgery. It
        was automatically generated by the electronic health record provider (Baritrax360) for the
        practice. Identical data was submitted to the MBSAQIP registry.
      </p>

      <figure className="mt-2">
        <ImageLightbox
          fullSrc={sleeveWeightLossGraph.url}
          fullWidth={1920}
          fullHeight={780}
          alt="Average excess weight loss percentage after laparoscopic sleeve gastrectomy at Virginia Bariatric Surgery, from 1 month through 9 years"
          caption="Average excess weight loss percentage after laparoscopic sleeve gastrectomy at Virginia Bariatric Surgery, from 1 month through 9 years."
        >
          <picture>
            <source srcSet={`${sleeveWeightLossGraphWebp720.url} 720w, ${sleeveWeightLossGraphWebp.url} 1920w`} sizes="(min-width: 768px) 26rem, calc(100vw - 3rem)" type="image/webp" />
          <img
            src={sleeveWeightLossGraph.url}
            srcSet={`${sleeveWeightLossGraph720.url} 720w, ${sleeveWeightLossGraph.url} 1920w`}
            sizes="(min-width: 768px) 26rem, calc(100vw - 3rem)"
            alt="Average excess weight loss percentage after laparoscopic sleeve gastrectomy at Virginia Bariatric Surgery, from 1 month through 9 years"
            width={1920}
            height={780}
            loading="lazy"
            decoding="async"
            className="block w-full h-auto rounded-lg"
          />
          </picture>
        </ImageLightbox>
        <figcaption className="mt-2 text-center text-sm text-muted-foreground">
          Average excess weight loss percentage after laparoscopic sleeve gastrectomy at Virginia Bariatric Surgery, from 1 month through 9 years.
        </figcaption>
      </figure>
      <div className="defer-render">
      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Weight regain after surgery</h2>

      <p className="mt-3 text-foreground/80">
        If you are already years out from a sleeve and the weight is creeping back, read our guide to{" "}
        <Link to="/resources/managing-weight-regain-after-bariatric-surgery" preload="intent" className="text-brand-deep underline hover:no-underline">
          managing weight regain after bariatric surgery
        </Link>
        , which covers the biology behind regain, GLP-1 medications after surgery, and revision options.
      </p>
      <SectionCta to="/resources/qualifications" label="cta_sleeve_after_results">See if You Qualify for Sleeve Surgery</SectionCta>
      <h3 className="mt-3 font-semibold text-foreground">Training matters</h3>
      <p className="mt-3 text-foreground/80">
        The large national registries (e.g., the MBSAQIP), provide data about the average long-term
        weight loss with sleeve surgery in the United States. The national average is steady at 60%,
        although weight loss varies from practice to practice. The important factor seems to be the
        focus of the operating surgeon.
      </p>
      <p className="mt-3 text-foreground/80">
        More than half the sleeve procedures done each year in the U.S. are performed by surgeons
        who lack formal fellowship training in weight loss surgery. Sleeves may be a small part of
        their overall case volume.
      </p>
      <p className="mt-3 text-foreground/80">
        When sleeve surgery is performed without formal training, the stomach often gets an
        over-cautious trim, not a proper volume reduction. Below are a few examples of patients with
        excessively large sleeves who were referred to Dr. Fitzer for sleeve revision:
      </p>

      <div className="mt-3 grid grid-cols-3 gap-3">
        <figure>
          <ImageLightbox fullSrc={sleeveAmateur1.url} fullWidth={829} fullHeight={829} alt="Dilated, over-large sleeve gastrectomy referred to Dr. Fitzer for revisional bariatric surgery">
            <picture>
              <source srcSet={`${sleeveAmateur1Webp220.url} 220w, ${sleeveAmateur1Webp440.url} 440w, ${sleeveAmateur1Webp680.url} 680w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" type="image/webp" />
              <img src={sleeveAmateur1Jpg220.url} srcSet={`${sleeveAmateur1Jpg220.url} 220w, ${sleeveAmateur1Jpg440.url} 440w, ${sleeveAmateur1Jpg680.url} 680w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" alt="Dilated, over-large sleeve gastrectomy referred to Dr. Fitzer for revisional bariatric surgery" width={829} height={829} loading="lazy" decoding="async" className="w-full h-auto rounded-lg bg-black" />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-1 text-xs text-muted-foreground text-center">Dilated sleeve referred for revision.</figcaption>
        </figure>
        <figure>
          <ImageLightbox fullSrc={sleeveAmateur2.url} fullWidth={1167} fullHeight={1167} alt="Upper GI study showing an incomplete 'trimmed' sleeve gastrectomy with retained fundus, sent to Dr. Fitzer for repair">
            <picture>
              <source srcSet={`${sleeveAmateur2Webp220.url} 220w, ${sleeveAmateur2Webp440.url} 440w, ${sleeveAmateur2Webp680.url} 680w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" type="image/webp" />
              <img src={sleeveAmateur2Png220.url} srcSet={`${sleeveAmateur2Png220.url} 220w, ${sleeveAmateur2Png440.url} 440w, ${sleeveAmateur2Png680.url} 680w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" alt="Upper GI study showing an incomplete 'trimmed' sleeve gastrectomy with retained fundus, sent to Dr. Fitzer for repair" width={1167} height={1167} loading="lazy" decoding="async" className="w-full h-auto rounded-lg bg-black" />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-1 text-xs text-muted-foreground text-center">Incomplete "trim" with retained fundus.</figcaption>
        </figure>
        <figure>
          <ImageLightbox fullSrc={sleeveAmateur3.url} fullWidth={685} fullHeight={685} alt="CT scan of an oversized post-sleeve stomach with poor restriction, evaluated by Dr. Fitzer for sleeve revision surgery">
            <picture>
              <source srcSet={`${sleeveAmateur3Webp220.url} 220w, ${sleeveAmateur3Webp440.url} 440w, ${sleeveAmateur3Webp.url} 685w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" type="image/webp" />
              <img srcSet={`${sleeveAmateur3Png220.url} 220w, ${sleeveAmateur3Png440.url} 440w, ${sleeveAmateur3.url} 685w`} src={sleeveAmateur3Png220.url} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" alt="CT scan of an oversized post-sleeve stomach with poor restriction, evaluated by Dr. Fitzer for sleeve revision surgery" width={685} height={685} loading="lazy" decoding="async" className="w-full h-auto rounded-lg bg-black" />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-1 text-xs text-muted-foreground text-center">Oversized post-sleeve stomach — poor restriction.</figcaption>
        </figure>
      </div>

      <p className="mt-3 text-foreground/80">
        The other type of sleeve surgeon is the bariatric surgeon. Bariatric surgeons typically have
        one or more years of formal fellowship training under their belt, and their practices are
        devoted exclusively to bariatric medicine and surgery.
      </p>
      <p className="mt-3 text-foreground/80">
        Dr. Fitzer is this kind. He completed a year-long bariatric surgery fellowship at the
        University of Missouri in 2005-2006. Since fellowship, nearly 100% of his annual caseload
        has been bariatric procedures.
      </p>
      <p className="mt-3 text-foreground/80">
        Bariatric surgeons can be relied on to perform proper stomach reduction. Here are a few
        examples of imaging studies from Dr. Fitzer's own sleeve patients (identifying information
        removed):
      </p>

      <div className="mt-3 grid grid-cols-3 gap-3">
        <figure>
          <ImageLightbox fullSrc={sleeveFitzer1.url} fullWidth={680} fullHeight={680} alt="Upper GI contrast study of a properly narrowed gastric sleeve created by Dr. Fitzer at Virginia Bariatric Surgery">
            <picture>
              <source srcSet={`${sleeveFitzer1Webp220.url} 220w, ${sleeveFitzer1Webp440.url} 440w, ${sleeveFitzer1Webp.url} 680w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" type="image/webp" />
              <img srcSet={`${sleeveFitzer1Png220.url} 220w, ${sleeveFitzer1Png440.url} 440w, ${sleeveFitzer1.url} 680w`} src={sleeveFitzer1Png220.url} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" alt="Upper GI contrast study of a properly narrowed gastric sleeve created by Dr. Fitzer at Virginia Bariatric Surgery" width={680} height={680} loading="lazy" decoding="async" className="w-full h-auto rounded-lg bg-black" />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-1 text-xs text-muted-foreground text-center">Upper GI contrast study — properly sized sleeve by Dr. Fitzer.</figcaption>
        </figure>
        <figure>
          <ImageLightbox fullSrc={sleeveFitzer2.url} fullWidth={823} fullHeight={823} alt="Post-operative imaging of a slim, tubular gastric sleeve after laparoscopic sleeve gastrectomy by Dr. Fitzer">
            <picture>
              <source srcSet={`${sleeveFitzer2Webp220.url} 220w, ${sleeveFitzer2Webp440.url} 440w, ${sleeveFitzer2Webp.url} 823w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" type="image/webp" />
              <img src={sleeveFitzer2Png220.url} srcSet={`${sleeveFitzer2Png220.url} 220w, ${sleeveFitzer2Png440.url} 440w, ${sleeveFitzer2.url} 823w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" alt="Post-operative imaging of a slim, tubular gastric sleeve after laparoscopic sleeve gastrectomy by Dr. Fitzer" width={823} height={823} loading="lazy" decoding="async" className="w-full h-auto rounded-lg bg-black" />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-1 text-xs text-muted-foreground text-center">Slim, tubular sleeve anatomy — Dr. Fitzer, Northern Virginia.</figcaption>
        </figure>
        <figure>
          <ImageLightbox fullSrc={sleeveFitzer3.url} fullWidth={833} fullHeight={833} alt="Contrast imaging of a Dr. Fitzer sleeve gastrectomy showing correct narrow diameter along the entire staple line">
            <picture>
              <source srcSet={`${sleeveFitzer3Webp220.url} 220w, ${sleeveFitzer3Webp440.url} 440w, ${sleeveFitzer3Webp.url} 833w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" type="image/webp" />
              <img src={sleeveFitzer3Jpg220.url} srcSet={`${sleeveFitzer3Jpg220.url} 220w, ${sleeveFitzer3Jpg440.url} 440w, ${sleeveFitzer3.url} 833w`} sizes="(min-width: 1024px) 131px, (min-width: 640px) calc((100vw - 7.5rem) / 3), calc((100vw - 4.5rem) / 3)" alt="Contrast imaging of a Dr. Fitzer sleeve gastrectomy showing correct narrow diameter along the entire staple line" width={833} height={833} loading="lazy" decoding="async" className="w-full h-auto rounded-lg bg-black" />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-1 text-xs text-muted-foreground text-center">Narrow diameter along the entire staple line.</figcaption>
        </figure>
      </div>

      <p className="mt-3 text-foreground/80">
        When someone loses very little after a sleeve or regains most of the lost weight, the sleeve
        may be at fault. The good news is that an underperforming sleeve can usually be repaired
        without much difficulty. See{" "}
        <Link to="/services/revisions" className="text-brand-logo underline hover:opacity-80">
          revision surgery in Virginia
        </Link>
        .
      </p>
      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Health benefits beyond weight loss</h2>
      <p className="mt-3 text-foreground/80">
        Losing weight with the sleeve often improves obesity-related conditions, and in many cases
        clears them entirely.{" "}
        <Link to="/resources/obesity-and-diabetes" className="text-brand-mid underline">
          Type 2 diabetes
        </Link>
        , high blood pressure, high cholesterol, sleep apnea,
        and joint pain all tend to get better.
      </p>
      <p className="mt-3 text-foreground/80">
        Blood sugar control often improves within days of surgery, long before you have lost much
        weight. Favorable changes in your gut hormones drive that early effect.
      </p>
      <p className="mt-3 text-foreground/80">
        The sleeve also offers several practical advantages over more complex operations:
      </p>
      <ul className="mt-2 list-disc pl-6 text-foreground/80 space-y-1">
        <li>It is a simpler operation than gastric bypass, with a shorter time under anesthesia.</li>
        <li>The hospital stay is usually a single night.</li>
        <li>Complication rates are low.</li>
        <li>Nutrient absorption stays close to normal, because the small intestine is untouched.</li>
        <li>Your stomach and intestine remain reachable by endoscope, which matters if you ever need one.</li>
      </ul>

      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Recovery after the sleeve operation</h2>
      <h3 className="mt-3 font-semibold text-foreground">Recovery timeline</h3>
      <p className="mt-3 text-foreground/80">
        The hospital stay is short. Most patients go home after one night and return to normal
        activities within four weeks.
      </p>
      <p className="mt-3 text-foreground/80">
        Your diet advances in stages. You start clear liquids in the hospital, move to liquids and
        protein shakes at home for the first week, then spend a week on pureed and soft foods. After
        about eight weeks you are back to regular solid food, in much smaller portions than before
        surgery.
      </p>
      <p className="mt-3 text-foreground/80">
        Daily vitamins begin the day you get home.{" "}
        <a
          href="https://virginiabariatric.com/__l5e/assets-v1/0a79aabf-27ff-4fa0-843d-ba9bb497b736/Nutritional_Supplement_Guidelines.pdf"
          target="_blank"
          rel="noopener noreferrer"
          type="application/pdf"
          className="text-brand-logo underline hover:opacity-80"
        >
          The recommended vitamin supplements can be viewed or downloaded here.
        </a>{" "}
        Over your first year you will see Dr. Fitzer and his dietitian regularly.
      </p>
      <p className="mt-3 text-foreground/80">
        Many patients find the shift to smaller meals easier than they feared. Even so, one-on-one
        work with an experienced eating coach makes a real difference. Building new eating habits
        takes time and support, and our team provides both throughout.
      </p>

      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Risks and side effects</h2>
      <p className="mt-3 text-foreground/80">
        Sleeve gastrectomy has a strong safety record, and serious complications are rare. Most of
        the risks are the treatable problems that are occasionally seen after any kind of surgery:
        bleeding, infection, and blood clots.
      </p>
      <p className="mt-3 text-foreground/80">
        A complication of great concern is a leak from the stomach staple line. Leaks are rare,
        thankfully. When they happen, it’s usually within the first few weeks. They are also
        treatable, but treatment should not be delayed.
      </p>
      <p className="mt-3 text-foreground/80">
        Early side effects are usually mild and temporary. Nausea, fatigue, and soreness at the
        incisions typically settle within the first few weeks as your diet advances.
      </p>
      <p className="mt-3 text-foreground/80">
        Long term complications are uncommon, except for one. Some 10 or 20% of patients get new or worse acid reflux.
      </p>

      <h2 id="acid-reflux-and-the-sleeve" className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Acid reflux and the sleeve</h2>
      <p className="mt-3 text-foreground/80">
        Why should sleeve surgery cause reflux? The pictures below help explain it.
      </p>

      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
        <figure>
          <ImageLightbox
            fullSrc={sleeveRefluxNormal}
            alt="Medical illustration of a patient with a normal stomach lying flat on their back, showing the stomach, esophagus, and gastroesophageal junction with fluid remaining in the stomach and no reflux"
            caption="Patient with normal stomach sleeping flat on back"
          >
            <picture>
              <source srcSet={`${sleeveRefluxNormalWebp680.url} 680w, ${sleeveRefluxNormalWebp} 1335w`} sizes="(min-width: 640px) 202px, calc(100vw - 3rem)" type="image/webp" />
              <img
                src={sleeveRefluxNormal}
                srcSet={`${sleeveRefluxNormalPng680.url} 680w, ${sleeveRefluxNormal} 1335w`}
                sizes="(min-width: 640px) 202px, calc(100vw - 3rem)"
                alt="Medical illustration of a patient with a normal stomach lying flat on their back, showing the stomach, esophagus, and gastroesophageal junction with fluid remaining in the stomach and no reflux"
                width={1335}
                height={682}
                loading="lazy"
                decoding="async"
                className="w-full h-auto rounded-lg"
              />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-1 text-xs text-muted-foreground text-center">
            Patient with normal stomach sleeping flat on back (click to enlarge)
          </figcaption>
        </figure>
        <figure>
          <ImageLightbox
            fullSrc={sleeveRefluxPostSleeve}
            alt="Medical illustration of a sleeve gastrectomy patient lying flat on their back, showing the tubular stomach, swallowed liquid within the sleeve, and refluxed liquid in the esophagus"
            caption="Sleeve gastrectomy patient sleeping flat on back (supine)"
          >
            <picture>
              <source srcSet={`${sleeveRefluxPostSleeveWebp680.url} 680w, ${sleeveRefluxPostSleeveWebp} 1335w`} sizes="(min-width: 640px) 202px, calc(100vw - 3rem)" type="image/webp" />
              <img
                src={sleeveRefluxPostSleeve}
                srcSet={`${sleeveRefluxPostSleevePng680.url} 680w, ${sleeveRefluxPostSleeve} 1335w`}
                sizes="(min-width: 640px) 202px, calc(100vw - 3rem)"
                alt="Medical illustration of a sleeve gastrectomy patient lying flat on their back, showing the tubular stomach, swallowed liquid within the sleeve, and refluxed liquid in the esophagus"
                width={1335}
                height={682}
                loading="lazy"
                decoding="async"
                className="w-full h-auto rounded-lg"
              />
            </picture>
          </ImageLightbox>
          <figcaption className="mt-1 text-xs text-muted-foreground text-center">
            Sleeve gastrectomy patient sleeping flat on back (supine) (click to enlarge)
          </figcaption>
        </figure>
      </div>

      <p className="mt-3 text-foreground/80">
        Notice how the normal stomach contains more fluid, yet the waterline settled below the opening of the esophagus.
      </p>
      <p className="mt-3 text-foreground/80">
        In the sleeved stomach, the fluid sits on top of the esophageal opening. While the patient lays that way, gravity will keep trying to pull the acidic juice back into the esophagus.  
      </p>

      <p className="mt-3 text-foreground/80">
        It’s normal for the esophagus to get some exposure to stomach acid. Reflux symptoms and esophageal damage only tend to develop when the daily duration of exposure rises above a threshold of 4-6%. The extra nighttime acid exposure after a sleeve pushes some patients over that symptom threshold.
      </p>
      <p className="mt-3 text-foreground/80">
        A hiatal hernia often contributes to reflux after a sleeve, and when one is found it is repaired at the same operation — see{" "}
        <Link to="/services/hiatal-hernia-surgery" hash="reflux-after-sleeve" preload="intent" className="text-brand-deep underline hover:no-underline">hiatal hernia repair</Link>.
      </p>
      <SectionCta to="/appointments" label="cta_sleeve_after_reflux">Ask Which Surgery Fits Your Reflux</SectionCta>

      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Surgery and follow-up near Herndon, Reston and Fairfax</h2>
      <p className="mt-3 text-foreground/80">Sleeve gastrectomy is done at INOVA Fair Oaks Hospital in Fairfax, and most patients go home after one night. Pre-op visits and follow-up are at our Herndon office, an easy trip from Reston, Loudoun County and western Fairfax. Patients from farther away can start with a telehealth consultation.</p>
      <p className="mt-3 text-foreground/80">Comparing options? See <Link to="/services/bypass" className="text-brand-deep underline hover:no-underline">gastric bypass in Northern Virginia</Link>, or <Link to="/services/esg" className="text-brand-deep underline hover:no-underline">endoscopic sleeve gastroplasty (ESG) in Northern Virginia</Link> if you would prefer a nonsurgical approach.</p>

      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Frequently asked questions</h2>

      <h3 className="mt-3 font-semibold text-foreground">Is any part of my stomach or intestine bypassed?</h3>
      <p className="mt-1 text-foreground/80">
        No. The sleeve removes part of your stomach, but it does not reroute your intestines. Food
        follows its normal path. That is one reason nutrient absorption holds up better than it does
        after a gastric bypass.
      </p>

      <h3 className="mt-3 font-semibold text-foreground">Sleeve or bypass — which is better?</h3>
      <p className="mt-1 text-foreground/80">
        Both are excellent operations, with similar weight loss and similar rates of diabetes
        remission. The sleeve is simpler and carries fewer complications. Bypass is often the better
        choice if you have significant acid reflux or certain metabolic conditions. The right answer
        is individual. See our detailed{" "}
        <Link to="/services/bypass-vs-sleeve" className="text-brand-deep underline hover:no-underline">
          sleeve vs. bypass comparison
        </Link>{" "}
        for a side-by-side look.
      </p>

      <h3 className="mt-3 font-semibold text-foreground">Can the sleeve be reversed?</h3>
      <p className="mt-1 text-foreground/80">
        No. Part of your stomach is removed permanently, so the sleeve cannot be undone. It can,
        however, be converted to another operation later if you ever need that.
      </p>

      <h3 className="mt-3 font-semibold text-foreground">How long is recovery after gastric sleeve surgery?</h3>
      <p className="mt-1 text-foreground/80">
        Most patients stay one night in the hospital and return to normal activities within about
        four weeks. You start on a liquid diet right away, then move through pureed, soft, and
        regular foods over the next eight weeks.
      </p>

      <h3 className="mt-3 font-semibold text-foreground">Is gastric sleeve covered by insurance?</h3>
      <p className="mt-1 text-foreground/80">
        Many major insurers cover sleeve gastrectomy when you meet their medical criteria, usually a
        BMI of 40 or higher, or 35 or higher with an obesity-related condition. Our team verifies
        your benefits and walks you through authorization. Our{" "}
        <Link to="/resources/insurance-coverage" className="text-brand-deep underline hover:no-underline">
          insurance coverage guide
        </Link>{" "}
        has plan-specific detail on Anthem BCBS, Aetna, Medicare, and others. If you are covering
        the cost yourself,{" "}
        our self-pay page lists{" "}
        <Link to="/self-pay-bariatric-surgery" className="text-brand-deep underline hover:no-underline">
          the price of sleeve gastrectomy
        </Link>{" "}
        and what is included.
      </p>
      <SectionCta to="/resources/insurance-coverage" label="cta_sleeve_after_insurance">Check Your Sleeve Coverage</SectionCta>

      <h3 className="mt-3 font-semibold text-foreground">What diet do I follow after sleeve gastrectomy?</h3>
      <p className="mt-1 text-foreground/80">
        Eating advances week by week for eight weeks: clear liquids, then full liquids and protein
        shakes, then pureed and soft foods, and finally regular solid food.{" "}
        <a
          href={sleevePostoperativeDiet.url}
          download={sleevePostoperativeDiet.original_filename}
          target="_blank"
          rel="noopener noreferrer"
          type="application/pdf"
          className="text-brand-deep underline hover:no-underline"
        >
          Sleeve-specific diet instructions can be found here,
        </a>{" "}
        Our dietitian is there to support you through every stage.
      </p>

      <h2 className="mt-6 text-[1.35rem] md:text-[1.6875rem] font-serif">Next steps: schedule a consultation</h2>
      <p className="mt-3 text-foreground/80">
        Considering the sleeve? The first step is a consultation. We review your health history and
        your goals, and we figure out together whether the sleeve is the right option for you.
      </p>
      <p className="mt-3 text-foreground/80">
        Not using insurance? See{" "}
        <Link to="/self-pay-bariatric-surgery" hash="gastric-sleeve-cost" className="text-brand-deep underline hover:no-underline">
          how much a gastric sleeve costs
        </Link>{" "}
        self-pay: an estimated $19,200, which covers the surgeon fee, one hospital day at INOVA Fair
        Oaks Hospital, an anesthesia estimate, and a year of routine follow-up with Dr. Fitzer. You
        can also review our{" "}
        <Link to="/resources/prosper" className="text-brand-deep underline hover:no-underline">
          financing options
        </Link>.
      </p>


      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link to="/appointments" className="rounded-full bg-primary px-7 py-3 text-sm font-medium text-primary-foreground hover:opacity-90">
          Request a consultation
        </Link>
        <WeightLossOptionsButtons />
      </div>

      <div className="mt-8 text-sm text-foreground/70">
        <h2 className="font-medium">Selected medical references</h2>
        <ol className="mt-1 list-decimal space-y-1 pl-5">
          <li>
            Han Y, et al. Comparative analysis of weight loss and resolution of comorbidities between laparoscopic sleeve gastrectomy and Roux-en-Y gastric bypass: a systematic review and meta-analysis based on 18 studies. Int J Surg. 2020;76:101-110. doi:10.1016/j.ijsu.2020.02.035
          </li>
          <li>
            Guan B, et al. Mid-long-term Revisional Surgery After Sleeve Gastrectomy: a Systematic Review and Meta-analysis. Obes Surg. 2019;29:1965-1975. doi:10.1007/s11695-019-03842-3
          </li>
        </ol>
      </div>
      </div>


      <LastUpdated className="mt-10" />
      </article>
  );
}
